import * as THREE from 'three'

export default function createSliceUniforms()
{
  return {
    uSliceStart: new THREE.Uniform(1.75),
    uSliceArc: new THREE.Uniform(1.25),
  }
}
